import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
import getAccountInformationService from '../services/getAccountInformationService';
import MyAccountStatisticsData from 'owa-service/lib/contract/MyAccountStatisticsData';
import UnlimitedUnsignedInteger from 'owa-service/lib/contract/UnlimitedUnsignedInteger';

/**
 * Gets account information and stores it in the mailbox quota store
 */
export default action('getAccountInformation')(function getAccountInformation(): Promise<boolean> {
    return getAccountInformationService()
        .then(response => {
            if (response.WasSuccessful) {
                const mailbox = response.AccountInfo.Mailbox;
                const statistics = response.AccountInfo.Statistics;
                const sendReceiveQuota = mailbox.UseDatabaseQuotaDefaults
                    ? statistics.DatabaseProhibitSendReceiveQuota
                    : mailbox.ProhibitSendReceiveQuota;
                store.sendQuota = mailbox.UseDatabaseQuotaDefaults
                    ? statistics.DatabaseProhibitSendQuota
                    : mailbox.ProhibitSendQuota;

                store.usagePercentage = calculateUsagePercentage(statistics, sendReceiveQuota);
                store.usageInBytes = statistics.TotalItemSize.Value;
                store.sendReceiveQuota = sendReceiveQuota;
                return true;
            } else {
                return false;
            }
        })
        .catch(error => {
            return false;
        });
});

function calculateUsagePercentage(
    statistics: MyAccountStatisticsData,
    quota: UnlimitedUnsignedInteger
): number {
    if (quota.IsUnlimited) {
        if (statistics.TotalItemSize.IsUnlimited) {
            // Return 100% if both the quota and the total size are unlimited
            // This is as per ECP code.
            return 100;
        }

        if (statistics.TotalItemSize.Value > 0) {
            // Return constant size of "3%" to depict unlimited usage;
            // This is as per ECP code.
            return 3;
        }

        return 0;
    }

    // Return actual usage: [TotalItemSize / ProhibitSendReceiveQuota]
    return (statistics.TotalItemSize.Value / quota.Value) * 100;
}
